import { Tab, Tabs, Box, Divider, styled } from '../../Material/index'
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

interface BasicTabsProps {
  tabLabels: string[]
  tabContents: React.ReactNode[]
  dividerPosition?: 'absolute' | 'sticky' | 'static'
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <Box role="tabpanel" hidden={value !== index} id={`my-tabpanel-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </Box>
  )
}

const CustomTabsStyled = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent',
    display: 'none'
  }
})

const CustomTabStyled = styled(Tab)({
  textTransform: 'none',
  fontWeight: 700,
  '& .MuiTab-wrapper': {
    position: 'relative'
  },
  '&::after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    bottom: 0,
    left: '25%',
    width: '50%',
    borderBottom: '4px solid #1856ff',
    borderRadius: '4px',
    opacity: 0,
    transition: 'opacity 300ms',
    fontWeight: 700
  },
  '&.Mui-selected::after': {
    opacity: 1
  }
})

export const CustomTabs = ({
  dividerPosition = 'absolute',
  tabLabels,
  tabContents,
  selectedTab,
  setSelectedTab
}: BasicTabsProps & {
  selectedTab: number
  setSelectedTab: (tab: number) => void
}) => {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const newValueTab = newValue
    setSelectedTab(newValueTab)
  }

  return (
    <Box className="w-full flex flex-col items-center">
      <Box className="w-full max-w-[720px]">
        <CustomTabsStyled
          value={selectedTab}
          onChange={handleChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          {tabLabels.map((label, index) => (
            <CustomTabStyled key={`tab-${index}`} label={label} />
          ))}
        </CustomTabsStyled>
        <Box>
          <Divider
            flexItem={true}
            variant="fullWidth"
            style={{
              position: dividerPosition,
              left: 0,
              right: 0,
              zIndex: 500
            }}
          />
        </Box>
      </Box>
      <Box className="w-full">
        {tabContents.map((content, index) => (
          <TabPanel key={`tabpanel-${index}`} value={selectedTab} index={index}>
            {content}
          </TabPanel>
        ))}
      </Box>
    </Box>
  )
}
